import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=acacf9ba&scoped=true"
import script from "./tongji.vue?vue&type=script&lang=js"
export * from "./tongji.vue?vue&type=script&lang=js"
import style0 from "./tongji.vue?vue&type=style&index=0&id=acacf9ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acacf9ba",
  null
  
)

export default component.exports